function Cart() {}
Cart.prototype.initAddToCart = function(items) {
    var ajax = new Ajax();
    var self = this;
    var firstSelector = $('.add-to-cart-btn');
    if (items) {
        var arrayItem = [];
        items.forEach(function(item) {
            arrayItem.push($(item).find('.add-to-cart-btn')[0]);
        });
        firstSelector = arrayItem;
    }
    $(firstSelector).click(function(event) {
        if ($(this).attr('disabled') != 'disabled' && $(this).attr('type') === 'submit') {
            var productItem = $(this).parents('.variants');
            var productId = $(productItem).attr('id');
            productId = productId.match(/\d+/g);
            var variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
            var quantity = 1;
            ajaxAddToCart(variant_id, quantity);
        }
        event.preventDefault();
        return false;
    });
    if (items) {
        return;
    }
    $('.nt-product-action .btn--addtocart').click(function(event) {
        if ($(this).attr('disabled') != 'disabled') {
            var parent = $(this).parents('form');
            var variant_id;
            if (window.addToCartVariant) {
                variant_id = window.addToCartVariant.id
                var quantity = parent.find('.nt-product-quantity .js-qty input').val();
                ajaxAddToCart(variant_id, quantity);
            }
        }
        event.preventDefault();
        return false;
    });
    $('.nt-wishlist-page .wl-add').click(function(event) {
        var form = $(this).closest('form');
        var variant_id = form.find('input[name=id]').val();
        var quantity = 1;
        ajaxAddToCart(variant_id, quantity);
        event.preventDefault();
        return false;
    });
    $('.sca-qv-cartbtn').click(function(event) {
        $(".sca-qv-cartbtn").bind("DOMSubtreeModified", function(e) {
            if ($(this).prop('disabled') === false) {
                ajax.filterAjaxClick(null, self.renderCart, function() {
                    self.initRemoveToCart();
                });
            }
        });
        return false;
    });

    function ajaxAddToCart(variant_id, quantity) {
        $.ajax({
            type: "post",
            url: "/cart/add.js",
            data: 'quantity=' + quantity + '&id=' + variant_id,
            dataType: 'json',
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                ajax.filterAjaxClick(null, self.renderCart, function() {
                    self.initRemoveToCart();
                    toastr.success('Product' + ' <span style="font-weight:bold">' + msg.product_title + '</span>'  + ' was successfully added to your cart!');
                });
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t add to cart!');
                Ajax.hideLoading();
            }
        });
    };
}
Cart.prototype.initRemoveToCart = function() {
    var ajax = new Ajax();
    var self = this;
    $('.btn-remove-cart').each(function(index) {
        $(this).on('click', function(event) {
            ajaxRemoveToCart(index + 1);
            event.preventDefault();
        })
    })

    function ajaxRemoveToCart(line) {
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity=0&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                ajax.filterAjaxClick(null, self.renderCart, function() {
                    self.initRemoveToCart();
                    toastr.success('Product was successfully removed to your cart!');
                });
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t remove to cart!');
                Ajax.hideLoading();
            }
        });
    };
}
Cart.prototype.renderCart = function(data, callback) {
    var currentCart = $(".nt-header-top-cart");
    var newCart = $(data).find(".nt-header-top-cart");
    currentCart.replaceWith(newCart);
    if (callback) {
        callback();
    }
}
